import { UserMessageProps } from "@copilotkit/react-ui";
import styles from "./CustomUserMessage.module.scss";

export const CustomUserMessage = ( { message}: any) => {
  return (
    <div className={styles.container}>
      {message?.content}
    </div>
  );
};
